module.exports = __webpack_public_path__ + "svg/new-visa-small.17ff509e5eadc17f984ad6aa5654fc79.svg";